<style scoped>

  .register-button {
    min-width: 110px;
    margin-left: 10px;
  } 

  .register-item {
    font-size: 13px !important;
  }

</style>

<template>
  
  <div class="ui segment form-segment" :class="{ loading }">

    <h4 class="ui dividing header">Animal</h4>
    
    <div class="m-b-20">
      <button class="ui mini basic button" :class="{ disabled: !hasCustomer }" @click="$refs.registrationPicker.show()">
        <i class="search plus grey icon"></i> Selecionar
      </button>      
      <div class="ui mini basic pointing dropdown button register-button" :class="{ disabled: !hasCustomer }">
        <i class="plus blue icon"></i> Cadastrar<i class="dropdown icon"></i>
        <div class="menu">
          <a class="item register-item" @click="onCreateOwner()">Tutor</a>
          <a class="item register-item" @click="onCreateAnimal()">Animal</a>
          <a class="item register-item" @click="onCreateRegistration()">Ficha Cadastral</a>
        </div>
      </div>      
      <button v-show="cert.animalId" class="ui mini basic button m-l-10" @click="$refs.animalPicturesModal.show(cert.animalId)">
        <i class="camera violet icon"></i> Fotos
      </button>
      <router-link v-show="cert.animalId" class="ui mini basic button m-l-10" :to="`/entries/animal-registrations/${cert.animalRegistrationId}?historyBack=true`">
        <i class="search teal icon"></i> Visualizar Ficha
      </router-link>        
      <button v-show="cert.animalId" class="ui mini basic button m-l-10" @click="onRemoveRegistration()">
        <i class="times red icon"></i> Remover
      </button>        
    </div>

    <div v-if="cert.animalId" class="ui form animated fadeIn">
      <div class="fields">
        <div class="three wide field">
          <label class="form-label">Clínica</label>
          {{ cert.customer.shortName }}
        </div>
        <div class="two wide field">
          <label class="form-label">Ficha Cadastral</label>
          {{ cert.animalRegistration.registrationId }}
        </div>                  
        <div class="three wide field">
          <label class="form-label">Nome do Animal</label>
          {{ cert.animal.name }}
        </div>
        <div class="two wide field">
          <label class="form-label">
            Sexo
            <i v-if="cert.animal.sex == 'male'" class="mars blue icon"></i>
            <i v-if="cert.animal.sex == 'female'" class="venus pink icon"></i>
            <i v-if="cert.animal.sex == 'undefined'" class="question circle grey icon"></i>
          </label>
          <span v-if="cert.animal.sex == 'male'">Macho</span>
          <span v-if="cert.animal.sex == 'female'">Fêmea</span>
          <span v-if="cert.animal.sex == 'undefined'">Indefinido</span>
        </div>
        <div class="three wide field">
          <label class="form-label">Raça</label>
          {{ cert.animal.race.name }}
        </div>
        <div class="three wide field">
          <label class="form-label">Espécie</label>
          {{ cert.animal.race.species.name }}
        </div>
      </div>
      <div class="fields">
        <div v-if="cert.animal.birthDate" class="three wide field">
          <label class="form-label">Idade</label>
          {{ animalAge }}
        </div>
        <div v-else class="three wide field">
          <label class="form-label">Faixa Etária</label>
          {{ animalAge }}
        </div>
        <div class="five wide field">
          <label class="form-label">Tutor</label>
          {{ cert.animal.owner.name }}
        </div>
        <div class="two wide field">
          <label class="form-label">Telefone</label>
          {{ cert.animal.owner.phone }}
        </div>
        <div class="three wide field">
          <label class="form-label">Celular</label>
          {{ cert.animal.owner.mobile }}
        </div>
        <div class="three wide field">
          <label class="form-label">E-mail</label>
          {{ cert.animal.owner.email }}
        </div>
      </div>            
    </div>

    <p v-show="!cert.animalId" class="grey text animated fadeIn m-t-30">
      <i class="info circle icon"></i>
      {{ hasCustomer ? "Nenhum animal selecionado" : "Informe a clínica antes de selecionar um animal" }}
    </p>

    <animal-registration-picker ref="registrationPicker" :customer="cert.customer" @onPick="onPickRegistration" />    
    <animal-pictures-modal ref="animalPicturesModal" />
    <animal-form-modal ref="animalFormModal" @onSave="afterCreateAnimal" />
    <owner-form-modal ref="ownerFormModal" @onSave="afterCreateOwner" />
    <animal-registration-form-modal ref="registrationFormModal" @onSave="afterCreateRegistration" />

  </div>

</template>

<script>

  import moment from "@/utils/moment"
  import AnimalService from "@/services/animal-service"
  import AnimalRegistrationService from "@/services/animal-registration-service"
  import AnimalRegistrationPicker from "@/components/animal-registration-picker.vue"
  import AnimalPicturesModal from "@/pages/entries/animals/pictures-modal"
  import AnimalFormModal from "@/pages/entries/animals/form-modal"
  import OwnerFormModal from "@/pages/entries/owners/form-modal"
  import AnimalRegistrationFormModal from "@/pages/entries/animal-registrations/form-modal"

  export default {
    
    name: "AnimalSegment",

    data() {
      return {
        cert: {},
        createdOwner: null,
        createdAnimal: null,
        loading: false,
        animalService: new AnimalService(),
        registrationService: new AnimalRegistrationService(),
      }
    },

    components: {
      AnimalRegistrationPicker,
      AnimalPicturesModal,
      AnimalFormModal,
      OwnerFormModal,
      AnimalRegistrationFormModal,
    },

    mounted() {
      $(".register-button").dropdown()
    },

    computed: {

      hasCustomer() {
        return !!this.cert.customer
      },

      animalAge() {

        if (!this.cert.animal)
          return ""

        return this.cert.animal.birthDate ? moment.formatAge(this.cert.animal.birthDate) : this.getAgeRange() 
      },
    },

    methods: {

      getAgeRange() {        
        return AnimalService.getAgeRange(this.cert.animal)
      },

      init(cert) {
        this.cert = this.$cloneObject(cert)
      },

      setCustomer(customer) {
        
        this.cert.customer = customer

        if (!customer)
          this.onRemoveRegistration()

        this.refreshData()
      },      

      refreshData() {
        this.cert = this.$cloneObject(this.cert)
      },

      onPickRegistration(registration) {
        
        this.cert.animalRegistration = registration
        this.cert.animalRegistrationId = registration.id
        this.cert.animal = registration.animal
        this.cert.animalId = registration.animal.id
        this.cert.animal.owner = registration.owner
        
        this.onChange()
      },

      onRemoveRegistration() {

        this.cert.animalRegistration = null
        this.cert.animalRegistrationId = null
        this.cert.animal = null
        this.cert.animalId = null
        
        this.onChange()
      },

      onChange() {
        this.refreshData()
        this.$emit("onChange", this.cert)
      },

      onCreateOwner() {
        this.$refs.ownerFormModal.create()
      },

      afterCreateOwner(owner) {
        this.createdOwner = owner
        this.onCreateAnimal()
      },

      onCreateAnimal() {

        let data = {
          customer: this.cert.customer,
        }

        if (this.createdOwner)
          data.owner = this.createdOwner

        this.$refs.animalFormModal.create(data)
      },

      async afterCreateAnimal(animal) {        

        this.loading = true

        try {

          this.createdAnimal = await this.animalService.findById(animal.id)

          if (animal.customerId && animal.customerId == this.cert.customer.id) {
            const registration = await this.animalService.getRegistration(animal.id, animal.customerId)
            this.onPickRegistration(registration)
          } else {
            this.onCreateRegistration()
          }          
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.loading = false
        }
      },

      onCreateRegistration() {

        let registration = {
          customer: this.cert.customer,
        }

        if (this.createdAnimal)
          registration.animal = this.createdAnimal

        this.$refs.registrationFormModal.create(registration)
      },

      async afterCreateRegistration(registration) {

        this.loading = true

        try {

          let createdRegistration = await this.registrationService.findById(registration.id)

          this.onPickRegistration(createdRegistration)
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.loading = false
        }
      },
    },
  }

</script>